import React from 'react';
import { Icon } from '@brighterion/br-ui';

import styles from './RuleType.css';

const RuleType: React.FC<RuleTypeOptions> = ({ type }) => {
    const Pill = ({ iconName, label, dataTestId }: { iconName: string; label: string; dataTestId: string }) => (
        <span className={styles.pill} data-testid={dataTestId}>
            <Icon className={styles.icon} size='sm' name={iconName} /> {label}
        </span>
    );

    switch (type) {
        case 'Override':
            return <Pill iconName='collapse-to-symbol' label={type} dataTestId='Override-dataTest' />;

        case 'Advanced':
            return <Pill iconName='thunder' label={type} dataTestId='Advanced-dataTest' />;

        default:
            return <Pill iconName='bulb' label={type} dataTestId='Simple-dataTest' />;
    }
};

export default RuleType;
